"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.verifyTurnstile = void 0;

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

var _axios = _interopRequireDefault(require("axios"));

// NOTE: the n8n webhook checks the Turnstile token (and holds the Turnstile secret) before the login
// is called. It answers { success } instead of the usual response shape, so the raw axios answer is
// read. Turnstile can be switched off on n8n, the webhook then always answers with success
var verifyTurnstile = function verifyTurnstile() {
  var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return _axios.default.post("".concat(process.env.VUE_APP_API_N8N, "/webhook/verify-auth"), {
    token: token
  }, {
    headers: (0, _defineProperty2.default)({}, process.env.VUE_APP_SECRET_KEY, process.env.VUE_APP_SECRET_KEY_HASH)
  }).then(function (response) {
    return Boolean(response && response.data && response.data.success === true);
  }).catch(function () {
    return false;
  });
};

exports.verifyTurnstile = verifyTurnstile;